import(/* webpackMode: "eager" */ "/app/src/app/(main-app)/single-property/[id]/price-list/page.tsx");
